<template>
    <basicSearch :onSearchApi="onSearchApi" placeholder="搜索选手" v-bind="$attrs" v-on="$listeners"></basicSearch>
</template>

<script>

import basicSearch from '@/components/basic/search.vue';
import { searchPlayer } from '@/api/games/player';


export default {
    name: "player-search",
    components: {
        basicSearch
    },
    data () {
        return {
            onSearchApi: searchPlayer,
        }
    }
}
</script>
